import React from 'react'
import colors from '../../Colors.scss'

const ExhibitionIcon = ({ width = '24', height = '24', color = colors.color_sidebar_icon }) => {
  return (
      <svg
          width={width}
          height={height}
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
      >
          <path
            d="M15.25 8.172c-.061.067-.15.137-.25.207V2.5C15 1.122 13.879 0 12.5 0h-9A2.503 2.503 0 0 0 1 2.5v5.798c-.5-.295-.895-.502-.959-.333-.149.385.118.653.653 1.308s2.839 1.557 2.839 1.557v2.738c0 .804 1.663 2.023 2.524 2.023s1.514-.595 1.514-1.012V12.05c.12.081.301.13.505.159v2.37c0 .416.578 1.42 2.331 1.42 1.753 0 2.212-2.075 2.212-2.431v-2.529c1.247-.655 2.524-1.012 3.135-2.183.575-1.101.03-1.279-.504-.684zm-3.135 1.35H9.591c-.564 0-1.515.149-1.515.506v.327c-.049-.059-.076-.101-.076-.101-.415-.386-.831-.683-1.573-.653-.743.029-2.495-.09-3.505-.328-.271-.063-.593-.215-.922-.394V2.5C2 1.673 2.673 1 3.5 1h9c.827 0 1.5.673 1.5 1.5v6.402c-.808.347-1.707.62-1.885.62z"
            fill={color}
          />
          <ellipse
            cx="10.433" cy="6.926" rx="1.767" ry="1.77"
            fill={color}
          />
          <ellipse
            cx="5.777" cy="6.926" rx="1.767" ry="1.77"
            fill={color}
          />
      </svg>
  )
}

export default ExhibitionIcon
